import * as React from 'react';
import xlsxIcon from '../../../../../assets/xlsxIcon';
import pdfIcon from '../../../../../assets/pdfIcon';
import './ECheckPaymentDetailDesktop.scss';
import Modal from 'src/components/common/Modal/Modal';
import ECheckPaymentDetailsTable from '../ECheckPaymentDetailsTable';
import LocaleFormating from 'src/translation/localeFormating';
import InvoiceService from 'src/services/invoice';
import { downloadFile } from 'src/utils/downloadHelper';
import paySimpleServiceInstance from 'src/services/paySimple/paySimpleService';

interface IECheckPaymentDetailDesktopProps {
  onCloseModal: () => void;
  paymentDetails: any;
  updatePayment: (databaseId: number, params: any) => void;
}

interface IECheckPaymentDetailDesktopState {
  taker: string;
  note: string;
  showLoader: boolean;
}

const styles = {
  minWidth: '60%'
};

class ECheckPaymentDetailDesktop extends React.Component<
  IECheckPaymentDetailDesktopProps,
  IECheckPaymentDetailDesktopState
> {
  constructor(props: any) {
    super(props);

    this.state = {
      taker: '',
      note: '',
      showLoader: false
    };
  }

  private handleChangeTaker = (e: any) => {
    this.setState({
      taker: e.target.value
    });
  };

  private handleChangeNote = (e: any) => {
    this.setState({
      note: e.target.value
    });
  };

  private submitDisposition = () => {
    const { paymentDetails } = this.props;
    this.props.updatePayment(paymentDetails.databaseId, {
      disposition: 'AD',
      taker: this.state.taker,
      note: this.state.note
    });

    this.props.onCloseModal();
  };
  public printPdfEcheck = () => {
    this.doExport('pdf');
  };
  public printExcelEcheck = () => {
    this.doExport('xlsx');
  };
  public doExport = (type: string) => {
    const { paymentDetails } = this.props;
    if (type === 'pdf') {
      this.setState({ showLoader: true });
      paySimpleServiceInstance
        .exportSelectedecheckSummary(
          type,
          paymentDetails.paymentNumber,
          0,
          0,
          'admin'
        )
        .then((response: any) => {
          this.setState({ showLoader: false });
          downloadFile(response.data, `Payment_Summary.pdf`);
        })
        .catch(error => {
          this.setState({ showLoader: false });
          console.log(error);
        });
    } else if (type === 'xlsx') {
      this.setState({ showLoader: true });
      paySimpleServiceInstance
        .exportSelectedecheckSummary(
          type,
          paymentDetails.paymentNumber,
          0,
          0,
          'admin'
        )
        .then((response: any) => {
          this.setState({ showLoader: false });
          downloadFile(response.data, `Payment_Summary.xlsx`);
        })
        .catch(error => {
          this.setState({ showLoader: false });
          console.log(error);
        });
    }
  };

  public render() {
    const { paymentDetails } = this.props;

    return (
      <Modal handleCloseModal={this.props.onCloseModal} styles={styles}>
        <div className="rp-echeck-payment-details-desktop ">
          <div className="container-fluid">
            <div className="row">
              <div className="col-12 d-flex align-items-center justify-content-between">
                <h3 className="rp-echeck-payment-details-desktop-title">
                  Payment Detail
                </h3>
                <i
                  className="rpds-close close-modal"
                  onClick={this.props.onCloseModal}
                />
              </div>
            </div>
            <div className="row">
              <div className="col-12 d-flex">
                <h6 className="rp-echeck-payment-detail-payment-id-title">
                  Payment Id:{' '}
                  <span className="rp-echeck-payment-detail-payment-id">
                    {paymentDetails.paymentNumber}
                  </span>
                </h6>
              </div>
            </div>
            <div className="row rp-echeck-payment-details-desktop-details">
              <div className="col-6 rp-echeck-payment-details-desktop-info">
                <div className="rp-echeck-payment-details-desktop-item">
                  <h6 className="rp-echeck-payment-detail-field">
                    Cust code:{' '}
                    <span className="rp-echeck-payment-detail-data">
                      {paymentDetails.customerCode}
                    </span>
                  </h6>
                </div>
                <div className="rp-echeck-payment-details-desktop-item">
                  <h6 className="rp-echeck-payment-detail-field">
                    Pmt time:{' '}
                    <span className="rp-echeck-payment-detail-data">
                      {LocaleFormating.formatDate(
                        paymentDetails.paymentDateTime,
                        'short'
                      )}
                    </span>
                  </h6>
                </div>
                <div className="rp-echeck-payment-details-desktop-item">
                  <h6 className="rp-echeck-payment-detail-field">
                    Pmt type:{' '}
                    <span className="rp-echeck-payment-detail-data text-transform-none">
                      E-Check
                    </span>
                  </h6>
                </div>
                <div className="rp-echeck-payment-details-desktop-item">
                  <h6 className="rp-echeck-payment-detail-field">
                    Pmt amount:{' '}
                    <span className="rp-echeck-payment-detail-data">
                      {LocaleFormating.formatCurrency(
                        paymentDetails.paymentAmount
                      )}
                    </span>
                  </h6>
                </div>
                <div className="rp-echeck-payment-details-desktop-item">
                  <h6 className="rp-echeck-payment-detail-field">
                    Auth code:{' '}
                    <span className="rp-echeck-payment-detail-data text-transform-none">
                      {paymentDetails.authCode}
                    </span>
                  </h6>
                </div>
                <div className="rp-echeck-payment-details-desktop-item">
                  <h6 className="rp-echeck-payment-detail-field">
                    Email:{' '}
                    <span className="rp-echeck-payment-detail-data text-transform-none">
                      {paymentDetails.customerEmail}
                    </span>
                  </h6>
                </div>
              </div>
              <div className="col-6 rp-echeck-payment-details-desktop-info">
                <div className="rp-echeck-payment-details-desktop-item">
                  <h6 className="rp-echeck-payment-detail-field">
                    Database id:{' '}
                    <span className="rp-echeck-payment-detail-data">
                      {paymentDetails.databaseId}
                    </span>
                  </h6>
                </div>
                <div className="rp-echeck-payment-details-desktop-item">
                  <h6 className="rp-echeck-payment-detail-field">
                    Signature:{' '}
                    <span className="rp-echeck-payment-detail-data text-transform-none">
                      {paymentDetails.signature}
                    </span>
                  </h6>
                </div>
                <div className="rp-echeck-payment-details-desktop-item">
                  <h6 className="rp-echeck-payment-detail-field">
                    Ip address:{' '}
                    <span className="rp-echeck-payment-detail-data">
                      {paymentDetails.ipAddress}
                    </span>
                  </h6>
                </div>
                <div className="rp-echeck-payment-details-desktop-item">
                  <h6 className="rp-echeck-payment-detail-field">
                    Status:{' '}
                    {paymentDetails.status === 'APPROVED' ? (
                      <i className="rpds-check-circle" />
                    ) : (
                      <i className="rpds-error" />
                    )}
                    <span className="rp-echeck-payment-detail-data">
                      {paymentDetails.status}
                    </span>
                  </h6>
                </div>
                <div className="rp-echeck-payment-details-desktop-item">
                  <h6 className="rp-echeck-payment-detail-field">
                    Taker:{' '}
                    {paymentDetails.taker ? (
                      <span className="rp-echeck-payment-detail-data text-transform-none">
                        {paymentDetails.taker}
                      </span>
                    ) : (
                      <input
                        className="rp-echeck-payment-detail-desktop-input"
                        type="text"
                        value={this.state.taker}
                        onChange={this.handleChangeTaker}
                        required={true}
                      />
                    )}
                  </h6>
                </div>
                <div className="rp-echeck-payment-details-desktop-item">
                  <h6 className="rp-echeck-payment-detail-field">
                    Note:{' '}
                    {paymentDetails.note ? (
                      <span className="rp-echeck-payment-detail-data text-transform-none">
                        {paymentDetails.note}
                      </span>
                    ) : (
                      <input
                        className="rp-echeck-payment-detail-desktop-input"
                        type="text"
                        value={this.state.note}
                        onChange={this.handleChangeNote}
                      />
                    )}
                  </h6>
                </div>
              </div>
            </div>
            <div className="row">
              <div className="col-12">
                <div className="rp-divider" />
              </div>
            </div>
            <div className="row">
              <div className="col-6 d-flex justify-content-start">
                <h4 className="rp-echeck-payment-by-echeck">Pay by e-check</h4>
              </div>
              <div className="col-6">
                <h4>
                  Total Amount:{' '}
                  <span>
                    {LocaleFormating.formatCurrency(
                      paymentDetails.paymentAmount
                    )}
                  </span>
                </h4>
              </div>
            </div>
            <div className="row rp-echeck-payment-detail-disposition-button">
              <div className="col-7 d-flex">
                {/* <div className="print" onClick={this.printExcelEcheck}>
                  <img className="image-icon xlsx-icon" src={xlsxIcon} />
                </div>
                <div className="export" onClick={this.printPdfEcheck}>
                  <img className="image-icon" src={pdfIcon} />
                </div> */}
              </div>
              <div className="col-5 d-flex button-wrapper">
                {/* <div className=" d-flex"> */}
                <div className="print" onClick={this.printExcelEcheck}>
                  <img className="image-icon xlsx-icon" src={xlsxIcon} />
                </div>
                <div className="export" onClick={this.printPdfEcheck}>
                  <img className="image-icon" src={pdfIcon} />
                </div>
                {/* </div> */}
                <button
                  className="primary-button rp-disposition-button"
                  onClick={this.submitDisposition}
                  disabled={this.state.taker.length === 0}
                >
                  Disposition this payment
                </button>
              </div>
            </div>
          </div>
          <ECheckPaymentDetailsTable
            invoices={paymentDetails.echeckDetails}
            customerCode={paymentDetails.customerCode}
          />
        </div>
      </Modal>
    );
  }
}

export default ECheckPaymentDetailDesktop;
